// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3qOBy","tab":"ProcedureTabs_tab__42D3o"};